// extracted by mini-css-extract-plugin
export default {"additional-detail-field":"styles_additional-detail-field__ifSC0","saving":"styles_saving__9dfBR","sending":"styles_sending__TnmLs"};